const production = {
  APP_BASE_URL: "https://www.quickenloans.com",
  AUTH0_LOGIN_URL: "https://accounts.quickenloans.com/login",
  BFF_API_URL: "https://www.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "production",
  BFF_API_USER_DATA_URL: "https://www.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://refinance.quickenloans.com",
  PURCHASE_BASE_URL: "https://mortgage.quickenloans.com",
  GET_OFFERS_API: "https://gateway.quickenloans.com/api/click-offer/offers/v1"
};
const qa = {
  APP_BASE_URL: "https://qa.quickenloans.com",
  AUTH0_LOGIN_URL: "https://qa.accounts.quickenloans.com/login",
  BFF_API_URL: "https://shared-bff.qa.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "qa",
  BFF_API_USER_DATA_URL: "https://shared-bff.qa.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://refinance.qa.quickenloans.com",
  PURCHASE_BASE_URL: "https://qa.mortgagelhp.quickenloans.com",
  GET_OFFERS_API: "https://gateway.qa.quickenloans.com/api/click-offer/offers/v1"
};
const development = {
  APP_BASE_URL: "https://qa.quickenloans.com",
  AUTH0_LOGIN_URL: "https://qa.accounts.quickenloans.com/login",
  BFF_API_URL: "https://shared-bff.qa.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "development",
  BFF_API_USER_DATA_URL: "https://shared-bff.qa.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://refinance.qa.quickenloans.com",
  PURCHASE_BASE_URL: "https://qa.mortgagelhp.quickenloans.com",
  GET_OFFERS_API: "https://gateway.qa.quickenloans.com/api/click-offer/offers/v1"
};
const environments = {
  production,
  qa,
  development
};
const getEnvVariable = ({ currentEnv, keyToSearch, defaultValue = void 0 }) => {
  try {
    if (!currentEnv) {
      return defaultValue;
    }
    const config = environments[currentEnv];
    return (config == null ? void 0 : config[keyToSearch]) ?? defaultValue;
  } catch (error) {
    console.error("Something went wrong getting the environment variable", { keyToSearch, error });
    return defaultValue;
  }
};
const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  QA: "qa"
};
export {
  ENVIRONMENTS as E,
  getEnvVariable as g
};
//# sourceMappingURL=index-DF2r5-bd.js.map
